// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___11hAF","translateIcon":"styles-module__translateIcon___2UnTa","active":"styles-module__active___2QCNR"};